export default __webpack_public_path__ + "static/media/free.c3b481da.png";